/**
 * Canonical URL paths for the public field guide (species catalog) and the in-map field guide menu.
 * Legacy `/species` and `/maps/species` URLs redirect to these in `App.tsx`.
 */
export const LEGACY_PUBLIC_SPECIES_PATH_PREFIX = "/species";

export const LEGACY_MAP_SPECIES_PATH_PREFIX = "/maps/species";

export const PUBLIC_FIELD_GUIDE_BASE = "/field-guide";

export const MAP_FIELD_GUIDE_SEGMENT = "field-guide";

export const MAP_FIELD_GUIDE_BASE = `/maps/${MAP_FIELD_GUIDE_SEGMENT}`;

export function publicFieldGuideListPath(categoryUrlSegment?: string): string {
  if (!categoryUrlSegment) return PUBLIC_FIELD_GUIDE_BASE;
  return `${PUBLIC_FIELD_GUIDE_BASE}/${categoryUrlSegment}`;
}

export function publicFieldGuideDetailPath(
  categoryUrlSegment: string,
  slug: string,
): string {
  return `${PUBLIC_FIELD_GUIDE_BASE}/${categoryUrlSegment}/${slug}`;
}

export function mapFieldGuideDetailPath(slug: string): string {
  return `${MAP_FIELD_GUIDE_BASE}/${slug}`;
}
